/* limalimonas: las secciones aparecen suavemente al bajar */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  function setup() {
    var vh = window.innerHeight || 800;
    var sections = Array.prototype.slice.call(
      document.querySelectorAll('main .shopify-section, .shopify-section-group-footer-group')
    );
    var targets = sections.filter(function (el) {
      if (el.querySelector('[data-wf], [data-fc], .sticky-content--desktop')) return false;
      if (el.offsetHeight < 40) return false;
      // Lo que ya se ve al cargar no se anima: así no se demora la carga visible
      return el.getBoundingClientRect().top > vh * 0.9;
    });
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.add('lm-reveal');
      var cards = el.querySelectorAll('product-card');
      Array.prototype.forEach.call(cards, function (c, i) {
        c.classList.add('lm-reveal-item');
        c.style.setProperty('--lm-d', (Math.min(i, 7) * 90) + 'ms');
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('lm-in');
        // Al terminar se limpian las clases para no afectar nada fijo o pegajoso
        setTimeout(function () {
          el.classList.remove('lm-reveal', 'lm-in');
          Array.prototype.forEach.call(el.querySelectorAll('.lm-reveal-item'), function (c) {
            c.classList.remove('lm-reveal-item');
            c.style.removeProperty('--lm-d');
          });
        }, 1900);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
